import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé toda mi planificación de entrenamiento en un fin de semana. Ahora sé exactamente qué trabajar cada día para mejorar mi posición. Nunca más entreno improvisando a ver qué sale.',
  name: 'Tomás M.',
  location: 'Buenos Aires',
  role: 'Forward / Prop del Club San Albano'
}, {
  quote: 'La parte táctica cambió todo. Entendí el juego de fases como nunca antes. En 6 semanas mi DT me subió a primera después de dos años en reserva. Y sin lesionarme más en cada partido.',
  name: 'Facundo R.',
  location: 'Rosario',
  role: 'Medio Scrum / Club Atlético del Rosario'
}, {
  quote: 'Adapto la intensidad del entrenamiento según cómo llego cada semana en 5 minutos. Antes me llevaba horas buscar videos en YouTube para armar algo coherente para mi posición.',
  name: 'Valentina F.',
  location: 'Córdoba',
  role: 'Back / Ala del Club Jockey de Córdoba'
}];
export function Testimonials() {
  return <section className="py-10 md:py-20 bg-rugby-green-950 relative border-y border-rugby-green-800" data-id="element-358">
      <div className="container mx-auto px-4" data-id="element-359">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 max-w-6xl mx-auto" data-id="element-360">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.2
        }} className="bg-rugby-green-900 border border-rugby-green-700 p-8 rounded-2xl relative" data-id="element-361">
              <div className="flex gap-1 mb-4" data-id="element-362">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} className="text-rugby-gold-500 fill-rugby-gold-500" data-id="element-363" />)}
              </div>
              <p className="text-slate-300 italic mb-6 leading-relaxed" data-id="element-364">
                "{t.quote}"
              </p>
              <div className="mt-auto pt-6 border-t border-rugby-green-800" data-id="element-365">
                <p className="font-bold text-white text-lg" data-id="element-366">{t.name}</p>
                <p className="text-rugby-gold-400 text-sm font-medium" data-id="element-367">
                  {t.location}
                </p>
                <p className="text-slate-400 text-sm mt-1" data-id="element-368">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}